import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import Loader from "../components/atoms/Loader";
import { getUser } from '../api/usersController';
import { useUser } from "./UserContext";
import { identifyUserGuiding } from "@utils";

export const UserGuard = ({ children }) => {
  const { user, setUser } = useUser();

  useEffect(() => {
    const checkUser = async () => {
      try {
        const response = await getUser();
        if (response) {
          setUser(response);
          identifyUserGuiding(response);
        } else {
          setUser(false);
        }
      } catch (error) {
        setUser(false);
      }
    };

    if (user === null) {
      checkUser();
    }
  }, [user, setUser]);

  if (user === null) {
    return (
      <div className="page-layout">
        <Loader />
      </div>
    );
  }

  return user ? children : <Navigate to="/forbidden" />;
};
